import createEngineForUI from './createEngineForUI'
import { appendMapEditorPlayerToState, type EngineWasmSession } from './engineWasm'
import { setBootstrapStateFromBytes } from './setEngineState'
import { encodeStateMessage } from './engineWasmCodec'

export default function createEngineWithTwoPlayersForUI() {
  const engine = createEngineForUI()
  const rootBootstrapPromise = engine.bootstrapPromise
    ?? Promise.resolve(undefined as unknown as EngineWasmSession)

  engine.bootstrapPromise = rootBootstrapPromise.then(async () => {
    const nextState = await appendMapEditorPlayerToState(engine.state)
    return setBootstrapStateFromBytes(engine, encodeStateMessage(nextState))
  })

  return engine
}
